import { parseGalleryRoute } from '@/utils/gallery-utils'
import { getLogger } from '@/logger'
import { initializeGalleryAnalytics } from '@/services/gallery-analytics.service'

export function initializeGallery(): void {
  const route = parseGalleryRoute(window.location.pathname)
  const appContainer = document.getElementById('app')

  if (!appContainer) {
    getLogger().error('App container not found')
    return
  }

  if (route) {
    initializeGalleryAnalytics({ galleryId: route.shortId, preview: route.preview })

    const app = document.createElement('gallery-app')
    app.setAttribute('gallery-id', route.shortId)
    if (route.preview) {
      app.setAttribute('preview', '')
    }
    appContainer.appendChild(app)
  } else {
    getLogger().error('Invalid gallery route')
    const errorEl = document.createElement('gallery-error')
    errorEl.setAttribute('reason', 'not-found')
    appContainer.appendChild(errorEl)
  }
}
